import React from 'react';

export const ButtonPrevBack = ({steps, activeStep, dispatch, className }) => {


  let prevIndex=0

  if(steps[activeStep].id=="circumference"){
    for(let i=0; i<steps.length;i++){
      if(steps[i].id=="measurement"){
        prevIndex=i
      }
    }

  if (prevIndex === -1) return null;
  }
  else{
   prevIndex = activeStep - 1;

    if (prevIndex === -1) return null;

  }

  return (
    <button
      onClick={() => dispatch({
        type: "activeStep",
        value: prevIndex
      })}
    className="customizer-cta font-medium rounded uppercase text-sm w-11/12 px-8 py-[1.125rem] mt-2">
      <span className="">Back</span>
    </button>
  )
};